// Dashboard GraphQL Queries
// Optimized queries for fetching ClientCharge records

export const clientChargeByCompanyDashboard = /* GraphQL */ `
    query ClientChargeByCompany(
        $companyId: String
        $createdAtId: ModelClientChargeByCompanyCompositeKeyConditionInput
        $sortDirection: ModelSortDirection
        $filter: ModelClientChargeFilterInput
        $limit: Int
        $nextToken: String
    ) {
        clientChargeByCompany(
            companyId: $companyId
            createdAtId: $createdAtId
            sortDirection: $sortDirection
            filter: $filter
            limit: $limit
            nextToken: $nextToken
        ) {
            items {
                id
                clientId
                orderId
                stripe_refund_charge
                amount
                amount_refunded
                currency
                description
                createdAt
            }
            nextToken
        }
    }
`;
